import Entity from '../entity'

export default class AuditLog extends Entity<number>{
    user_id: number;
    model_id: number;
    model: string;
    method: string;
    exception: string;
}


